import React from "react"

import Layout from "../components/Layout"
import Header from "../components/Header"
import { StaticImage } from "gatsby-plugin-image"

const backers = [
  {
    name: "300 ventures",
    hideName: true,
    link: "https://www.linkedin.com/company/300-ventures/",
    logo: (
      <StaticImage
        width={120}
        src="../images/our-backers/300ventures-logo.webp"
        alt="300ventures"
      />
    ),
  },
  {
    name: "Sujayath Ali",
    link: "https://www.linkedin.com/in/sujayath/",
    logo: (
      <StaticImage
        width={120}
        src="../images/our-backers/sujayath.jpeg"
        alt="sujayath"
        className="rounded-full"
      />
    ),
  },
  {
    name: "Sirish Kosaraju",
    link: "https://www.linkedin.com/in/sirishkosaraju/",
    logo: (
      <StaticImage
        width={120}
        src="../images/our-backers/sireesh.jpg"
        alt="sireesh"
        className="rounded-full"
      />
    ),
  },
  {
    name: "Rajesh Padinjaremadam",
    link: "https://www.linkedin.com/in/rajeshtp/",
    logo: (
      <StaticImage
        width={120}
        src="../images/our-backers/rajesh.jpg"
        alt="rajesh"
        className="rounded-full"
      />
    ),
  },
  {
    name: "Mohammed Hisamuddin",
    link: "https://www.linkedin.com/in/hisamuddin/",
    logo: (
      <StaticImage
        width={120}
        src="../images/our-backers/hisam.jpeg"
        alt="hisam"
        className="rounded-full"
      />
    ),
  },
  {
    name: "Sharique Samsudheen",
    link: "https://www.linkedin.com/in/shariquesamsudheen/",
    logo: (
      <StaticImage
        width={120}
        src="../images/our-backers/sharique.jpeg"
        alt="sharique"
        className="rounded-full"
      />
    ),
  },
  {
    name: "Kerala Startup mission",
    hideName: true,
    link: "https://startupmission.kerala.gov.in/",
    logo: (
      <StaticImage
        width={200}
        src="../images/our-backers/startup.png"
        alt="startup"
        className="rounded-full"
      />
    ),
  },
]

export default function AboutUs() {
  return (
    <Layout
      title="About Premagic - AI Event Platform Innovation Leaders"
      description="Meet the team revolutionizing events with AI. Learn our mission to transform attendees into passionate brand advocates."
      keywords={[
        "about Premagic team, AI event platform founders, event technology company, event innovation leaders, photo sharing platform founders, conference technology team, event AI company mission, corporate event platform company, networking technology founders, event tech startup, MICE platform company, digital event solutions team, event engagement platform, AI technology events, event platform leadership",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "About Us", url: "/about-us/" },
      ]}
    >
      <Header />
      <section id="about" className="pm-container py-12">
        <h1 className="font-light text-4xl py-10">
          About <span className="font-bold">Us</span>
        </h1>
        <div className="flex justify-center">
          <p className="w-full md:w-2/3 text-center italic">
            We are an AI-powered event tech platform designed to enhance organic
            event marketing. Our mission? To turn every attendee into a content
            creator. We offer comprehensive support from pre-event to
            post-event, enhancing the organic reach of companies and brands that
            use events in their marketing.
          </p>
        </div>
        <h3 className="font-light text-4xl py-10 mt-16">
          Our <span className="font-bold">Backers</span>
        </h3>
        <div className="grid grid-rows-4 grid-cols-2 gap-12 md:grid-cols-3">
          {backers.map(backer => (
            <a
              key={backer.name}
              href={backer.link}
              target="_blank"
              rel="noreferrer"
              className="flex flex-col justify-center	items-center"
            >
              {backer.logo}
              {!backer.hideName && (
                <div className="font-bold text-gray-900 mt-4 text-center">
                  {backer.name}
                </div>
              )}
            </a>
          ))}
        </div>
      </section>
    </Layout>
  )
}
